(function () {
  'use strict';

  var REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

  if (!customElements.get('sui-product-tabs')) {
    class SuiProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        if (this.tabs.length < 2) return;

        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);

        var active = this.tabs.findIndex(function (tab) {
          return tab.getAttribute('aria-selected') === 'true';
        });

        this.select(active < 0 ? 0 : active, false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
      }

      onClick(event) {
        var tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;

        event.preventDefault();
        this.select(this.tabs.indexOf(tab), true);
      }

      onKeydown(event) {
        var tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;

        var current = this.tabs.indexOf(tab);
        var next = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = (current + 1) % this.tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = (current - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = this.tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.select(next, true);
        this.tabs[next].focus();
      }

      select(index, notify) {
        this.tabs.forEach(function (tab, i) {
          var selected = i === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          tab.classList.toggle('is-active', selected);
        });

        this.panels.forEach(function (panel, i) {
          var selected = i === index;
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);
        });

        if (!notify) return;

        var panel = this.panels[index];
        if (!panel) return;

        requestAnimationFrame(function () {
          panel.querySelectorAll('sai-upsell-accordion').forEach(function (el) {
            if (typeof el.resync === 'function') el.resync();
          });

          if (window.theme && window.theme.Slideshow) {
            panel.querySelectorAll('[data-slideshow]').forEach(function (el) {
              if (el.flickity && typeof el.flickity.resize === 'function') {
                el.flickity.resize();
              }
            });
          }

          window.dispatchEvent(new Event('resize'));
        });

        this.dispatchEvent(
          new CustomEvent('tabs:change', {
            bubbles: true,
            detail: { index: index, panel: panel, tab: this.tabs[index] }
          })
        );
      }
    }

    customElements.define('sui-product-tabs', SuiProductTabs);
  }

  if (!customElements.get('sai-upsell-accordion')) {
    class SaiUpsellAccordion extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
        if (!this.items.length) return;

        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.resync.bind(this));
          this.items.forEach(function (item) {
            var measure = item.querySelector('[data-accordion-measure]');
            if (measure) this.observer.observe(measure);
          }, this);
        }

        var initial =
          this.items.filter(function (item) {
            return item.classList.contains('is-open');
          })[0] || this.items[0];

        this.items.forEach(function (item) {
          this.setState(item, item === initial, false);
        }, this);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.observer) this.observer.disconnect();
      }

      get reduceMotion() {
        return window.matchMedia(REDUCED_MOTION).matches;
      }

      onClick(event) {
        var trigger = event.target.closest('[data-accordion-trigger]');
        if (!trigger || !this.contains(trigger)) return;

        var item = trigger.closest('[data-accordion-item]');
        var willOpen = !item.classList.contains('is-open');

        this.items.forEach(function (other) {
          this.setState(other, other === item && willOpen, true);
        }, this);
      }

      setState(item, open, animate) {
        var panel = item.querySelector('[data-accordion-panel]');
        var trigger = item.querySelector('[data-accordion-trigger]');
        if (!panel || !trigger) return;

        item.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

        if (open) {
          panel.removeAttribute('inert');
        } else {
          panel.setAttribute('inert', '');
        }

        if (!animate || this.reduceMotion) {
          panel.style.maxHeight = open ? 'none' : '0px';
          return;
        }

        if (open) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          var done = function (event) {
            if (event.target !== panel || event.propertyName !== 'max-height') return;
            panel.removeEventListener('transitionend', done);
            if (item.classList.contains('is-open')) panel.style.maxHeight = 'none';
          };
          panel.addEventListener('transitionend', done);
        } else {
          if (panel.style.maxHeight === 'none' || panel.style.maxHeight === '') {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
          void panel.offsetHeight;
          requestAnimationFrame(function () {
            panel.style.maxHeight = '0px';
          });
        }
      }

      resync() {
        this.items.forEach(function (item) {
          if (!item.classList.contains('is-open')) return;
          var panel = item.querySelector('[data-accordion-panel]');
          if (panel && panel.style.maxHeight !== 'none') {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        });
      }
    }

    customElements.define('sai-upsell-accordion', SaiUpsellAccordion);
  }
})();
